var map = {
	"./assets/clickable/youtube.svg": "a45c3e8234a7342db6b4",
	"./assets/disabled/youtube.svg": "89aaa4d40be926f93579",
	"./assets/original/youtube.svg": "cb3ecfb51162728ff08e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff848745b74bcb0c1fd3";